/**
 * Open image lightboxes (shared/Lightbox). They render in a body portal outside the store's
 * modal flags, so they register here and the back-navigation policy closes the topmost one
 * instead of sliding the panels underneath.
 */

const openLightboxCloses: Array<() => void> = []

/** Registers an open lightbox's close callback. Returns the unregister function. */
export function registerOpenLightbox(close: () => void): () => void {
    const entry = () => close()
    openLightboxCloses.push(entry)
    return () => {
        const index = openLightboxCloses.lastIndexOf(entry)
        if (index >= 0) openLightboxCloses.splice(index, 1)
    }
}

/** Closes the most recently opened lightbox. True when there was one to close. */
export function closeTopmostLightbox(): boolean {
    const close = openLightboxCloses[openLightboxCloses.length - 1]
    if (!close) return false
    close()
    return true
}
